/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12.1929 16.4989L11.7191 16.9877C10.4108 18.3374 8.28956 18.3374 6.98124 16.9877C5.67292 15.638 5.67292 13.4497 6.98124 12.1L8.11104 10.9344C9.31872 9.68853 11.2768 9.68853 12.4844 10.9344L12.6667 11.1224M11.8071 7.50106L12.2809 7.01229C13.5892 5.66257 15.7104 5.66257 17.0187 7.01229C18.3271 8.362 18.3271 10.5503 17.0187 11.9L15.8889 13.0656C14.6813 14.3115 12.7232 14.3115 11.5155 13.0656L11.3333 12.8776"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M12.1929 16.4989L11.7191 16.9877C10.4108 18.3374 8.28956 18.3374 6.98124 16.9877C5.67292 15.638 5.67292 13.4497 6.98124 12.1L8.11104 10.9344C9.31872 9.68853 11.2768 9.68853 12.4844 10.9344L12.6667 11.1224M11.8073 7.50106L12.2811 7.01229C13.5894 5.66257 15.7106 5.66257 17.0189 7.01229C18.3272 8.362 18.3272 10.5503 17.0189 11.9L15.8891 13.0656C14.6814 14.3115 12.7234 14.3115 11.5157 13.0656L11.3335 12.8776M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM17.5574 6.49028C15.9545 4.83657 13.3455 4.83657 11.7425 6.49028L11.2688 6.97905C10.9805 7.27647 10.9879 7.75129 11.2853 8.03959C11.5827 8.32788 12.0575 8.32049 12.3458 8.02307L12.8196 7.53429C13.8332 6.48857 15.4667 6.48857 16.4804 7.53429C17.5068 8.59312 17.5068 10.3192 16.4804 11.378L15.3506 12.5436C14.4376 13.4855 12.9673 13.4855 12.0542 12.5436L11.872 12.3556C11.5837 12.0582 11.1089 12.0508 10.8115 12.3391C10.5141 12.6274 10.5067 13.1022 10.795 13.3996L10.9772 13.5876C12.4795 15.1375 14.9253 15.1375 16.4276 13.5876L17.5574 12.422C19.1477 10.7814 19.1477 8.13088 17.5574 6.49028ZM8.64956 11.4564C9.56258 10.5145 11.0329 10.5145 11.9459 11.4564L12.1281 11.6444C12.4164 11.9418 12.8913 11.9492 13.1887 11.6609C13.4861 11.3726 13.4935 10.8978 13.2052 10.6004L13.023 10.4124C11.5206 8.86253 9.07486 8.86253 7.57251 10.4124L6.44272 11.578C4.85243 13.2186 4.85243 15.8691 6.44272 17.5097C8.04571 19.1634 10.6546 19.1634 12.2576 17.5097L12.7314 17.0209C13.0197 16.7235 13.0123 16.2487 12.7149 15.9604C12.4175 15.6721 11.9427 15.6795 11.6544 15.9769L11.1806 16.4657C10.1669 17.5114 8.53342 17.5114 7.51976 16.4657C6.49341 15.4069 6.49341 13.6808 7.51976 12.622L8.64956 11.4564Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M12.1929 16.4989L11.7191 16.9877C10.4108 18.3374 8.28956 18.3374 6.98124 16.9877C5.67292 15.638 5.67292 13.4497 6.98124 12.1L8.11104 10.9344C9.31872 9.68853 11.2768 9.68853 12.4844 10.9344L12.6667 11.1224M11.8073 7.50106L12.2811 7.01229C13.5894 5.66257 15.7106 5.66257 17.0189 7.01229C18.3272 8.362 18.3272 10.5503 17.0189 11.9L15.8891 13.0656C14.6814 14.3115 12.7234 14.3115 11.5157 13.0656L11.3335 12.8776"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12.1929 16.4989L11.7191 16.9877C10.4108 18.3374 8.28956 18.3374 6.98124 16.9877C5.67292 15.638 5.67292 13.4497 6.98124 12.1L8.11104 10.9344C9.31872 9.68853 11.2768 9.68853 12.4844 10.9344L12.6667 11.1224M11.8073 7.50106L12.2811 7.01229C13.5894 5.66257 15.7106 5.66257 17.0189 7.01229C18.3272 8.362 18.3272 10.5503 17.0189 11.9L15.8891 13.0656C14.6814 14.3115 12.7234 14.3115 11.5157 13.0656L11.3335 12.8776M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.7425 6.49028C13.3455 4.83657 15.9545 4.83657 17.5574 6.49028C19.1477 8.13088 19.1477 10.7814 17.5574 12.422L16.4276 13.5876C14.9253 15.1375 12.4795 15.1375 10.9772 13.5876L10.795 13.3996C10.5067 13.1022 10.5141 12.6274 10.8115 12.3391C11.1089 12.0508 11.5837 12.0582 11.872 12.3556L12.0542 12.5436C12.9673 13.4855 14.4376 13.4855 15.3506 12.5436L16.4804 11.378C17.5068 10.3192 17.5068 8.59312 16.4804 7.53429C15.4667 6.48857 13.8332 6.48857 12.8196 7.53429L12.3458 8.02307C12.0575 8.32049 11.5827 8.32788 11.2853 8.03959C10.9879 7.75129 10.9805 7.27647 11.2688 6.97905L11.7425 6.49028ZM11.9459 11.4564C11.0329 10.5145 9.56258 10.5145 8.64956 11.4564L7.51977 12.622C6.49341 13.6808 6.49341 15.4069 7.51977 16.4657C8.53342 17.5114 10.1669 17.5114 11.1806 16.4657L11.6544 15.9769C11.9427 15.6795 12.4175 15.6721 12.7149 15.9604C13.0123 16.2487 13.0197 16.7235 12.7314 17.0209L12.2576 17.5097C10.6546 19.1634 8.04571 19.1634 6.44272 17.5097C4.85243 15.8691 4.85243 13.2186 6.44272 11.578L7.57251 10.4124C9.07486 8.86253 11.5206 8.86253 13.023 10.4124L13.2052 10.6004C13.4935 10.8978 13.4861 11.3726 13.1887 11.6609C12.8913 11.9492 12.4164 11.9418 12.1281 11.6444L11.9459 11.4564Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
